import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "incident_type";

export const getIncidentTypeList = (currentTenantKey: string) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${currentTenantKey}/${apiURL}`, {
				...AuthHeader,
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const addIncidentTypeItem = (currentTenantKey: string, data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${url}/${currentTenantKey}/${apiURL}`, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				console.log("error", e);
				reject(e);
			});
	});
};

export const updateIncidentTypeItem = (
	currentTenantKey: string,
	uuid: string,
	data: any
) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/${currentTenantKey}/${apiURL}`,
				{
					filter: { _id: uuid },
					data: data,
					options: { upsert: true, new: true },
				},
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const deleteIncidentTypeItem = (currentTenantKey: string, uuid: any) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(`${url}/${currentTenantKey}/${apiURL}`, {
				params: {
					filter: JSON.stringify({ _id: uuid }),
				},
				...AuthHeader,
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
